import type { GeminiContent } from './types';

const AGENT_API_URL = process.env.REACT_APP_AGENT_API_URL
  || 'https://booking.trailernchu.co.jp/sys/agent/api.php';
const AGENT_API_KEY = 'nc-line-sync-key-2024';

export interface AgentChatRequest {
  system_instruction: string;
  contents: GeminiContent[];
  tools: Array<{ functionDeclarations: any[] }>;
}

export interface AgentChatResponse {
  success: boolean;
  content?: GeminiContent;
  error?: string;
  usage?: { input_tokens: number; output_tokens: number };
}

export async function postAgentChat(body: AgentChatRequest): Promise<AgentChatResponse> {
  const url = `${AGENT_API_URL}?action=chat&api_key=${AGENT_API_KEY}`;
  const res = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    // 上流 (Gemini) のエラーメッセージを下流の判定で活用するため十分な長さを確保
    // （200 字だと "function call" が "cal" で切れて regex 不一致になる事例があった）
    throw new Error(`agent api error: ${res.status} ${text.slice(0, 800)}`);
  }
  return res.json();
}
